import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { setTrustCondition, resetStoreData, REDUCER_NAME } from '../../reducer';

class FilterTrustability extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTrustability: [
        { value: 'Low', color: 'bg-l-color-3', isChecked: true },
        { value: 'Medium', color: 'bg-s-color-4', isChecked: true },
        { value: 'High', color: 'bg-s-color-3', isChecked: true },
      ],
    };
  }

  onClickCheckBox = value => {
    const { listTrustability } = this.state;

    const { setTrustCondition, resetStoreData } = this.props;
    const newListTab = listTrustability.map(item => {
      if (value === item.value)
        return {
          ...item,
          isChecked: !item.isChecked,
        };
      return {
        ...item,
      };
    });
    const arrCondition = [];
    newListTab.forEach(item => {
      if (item.isChecked) {
        return arrCondition.push(item.value);
      }
    });

    this.setState({ listTrustability: newListTab }, () => {
      resetStoreData('rumorsData');
      setTrustCondition(arrCondition);
    });
  };

  render() {
    const { listTrustability } = this.state;
    return (
      <div className="d-flex na-trust-filter-wrapper">
        <span className="text-span-na-trust">
          {I18n.t('newsAndAnalysis.Trustability')}
        </span>
        {listTrustability.map((item, index) => (
          <div
            key={`checkbox-${index}`}
            className="checkbox"
            style={{ position: 'relative' }}
          >
            <input
              checked={item.isChecked}
              onChange={() => {}}
              id={`checkbox-${index}`}
              type="checkbox"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.onClickCheckBox(item.value);
              }}
            />
            <label
              className="d-flex"
              htmlFor={`checkbox-${index}`}
              style={{ cursor: 'pointer' }}
            >
              <div style={{ width: 60 }} className={`label-text ${item.color}`}>
                {I18n.t(
                  `newsAndAnalysis.listTrustability.${item.value.toLowerCase()}`,
                )}
              </div>
            </label>
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rumorsData: state[REDUCER_NAME].rumorsData,
});

const mapDispatchToProps = dispatch => {
  return {
    setTrustCondition: arrCondition =>
      dispatch(setTrustCondition(arrCondition)),
    resetStoreData: storeName => dispatch(resetStoreData(storeName)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterTrustability);
